const DEFAULT_STATE = {
    groups: {}
};

export const variantInformationContent = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
    default:
        return state;
    }
};
